import { ReferralTopupsPanel } from './ReferralTopupsPanel'
import { DateRange } from 'react-day-picker'

type ReferralTopupsTabProps = {
  referralId: string
  dateRange?: DateRange
}

export const ReferralTopupsTab = ({ referralId, dateRange }: ReferralTopupsTabProps) => {
  return <ReferralTopupsPanel referralId={referralId} dateRange={dateRange} />
}

// Название вкладки для использования в TabGroup
export const REFERRAL_TOPUPS_TAB_LABEL = 'Входящие'

